import React, { Component } from 'react';
import { Form, reduxForm } from 'redux-form';
import Button from '../../../../components/Button';
import { FormField } from '../../../../components/CustomForm';
import PaddingBox from '../../../../components/PaddingBox';
import CheckboxAdapter from '../../../../components/adapters/form/Checkbox';
import { NumberTextboxAdapter } from '../../../../components/adapters/form/NumberTextboxAdapter';
import { codes } from '../../../../data/translations';
import { length, required } from '../../../../utils/formValidators';
import { FORM_ENTER_AUTHENTICATION_CODE } from '../../consts';

@reduxForm({
	form: FORM_ENTER_AUTHENTICATION_CODE,
	touchOnBlur: false,
})
export class AuthenticationTwoStepEnterCodeForm extends Component {
	constructor(props) {
		super(props);

		this.inputAuthCode = React.createRef();
	}

	componentDidMount() {
		const inputAuthCode = this.inputAuthCode.current;

		if (inputAuthCode && inputAuthCode.focus) {
			setTimeout(() => {
				inputAuthCode.focus();
			}, 300);
		}
	}

	render() {
		const { handleSubmit, handleAuthAppSend, translate } = this.props;

		return (
			<Form onSubmit={handleSubmit(handleAuthAppSend)}>
				<FormField
					component={NumberTextboxAdapter}
					name='code'
					validate={[
						required(),
						length({
							min: 6,
							max: 6,
						}),
					]}
					controlProps={{ isRequired: true }}
					componentProps={{ inputRef: this.inputAuthCode, pinCodeMode: true }}
				/>
				<PaddingBox topTiny>
					<FormField
						component={CheckboxAdapter}
						name='isPersistent'
						controlProps={{ position: 'right', inline: true }}
						componentProps={{
							label: translate(codes.user.rememberThisComputerForNDays, [30]),
						}}
					/>
				</PaddingBox>
				<PaddingBox topSmall>
					<Button
						type='submit'
						primary
						block
						size='small'
					>
						{translate(codes.user.verify)}
					</Button>
				</PaddingBox>
			</Form>
		);
	}
}
